mutation DuplicateTugOfWar($tugId: ID!) {
  tug: StreamToolsDuplicateTugOfWar(tugId: $tugId) {
    tugId
    eventId
    name
    broadcasterUserIds
    question
    status
    youtubeVotesEnabled
    dedupe
    totalVotes
    startedAt
    stoppedAt
    createdAt
    questionTextColor
    finalizedText
    finalizedTextColor
    backgroundColor
    chatCommandBackground
    barHeight
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    fontKey
    version
    optionA { displayText command voteCount voteCountByPlatform { twitch youtube } color textColor imageUrl }
    optionB { displayText command voteCount voteCountByPlatform { twitch youtube } color textColor imageUrl }
  }
}
